'use strict';

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.number.is-nan");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.number.constructor");

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var _taggedTemplateLiteral = _interopDefault(require('@babel/runtime/helpers/taggedTemplateLiteral'));

var React = require('react');

var React__default = _interopDefault(React);

var styled = _interopDefault(require('styled-components'));

var _extends = _interopDefault(require('@babel/runtime/helpers/extends'));

var _objectWithoutProperties = _interopDefault(require('@babel/runtime/helpers/objectWithoutProperties'));

var _typeof = _interopDefault(require('@babel/runtime/helpers/typeof'));

var Form = _interopDefault(require('react-jsonschema-form'));

var _require = require('styled-components'),
    css = _require.css,
    withTheme = _require.withTheme,
    ThemeContext = _require.ThemeContext;

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          background-color: #ffcfcf;\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: inherit;\n  padding: 10px;\n  border-radius: 4px;\n  border: none;\n  width: 100%;\n  background-color: #fff;\n  &:disabled {\n    background-color: #eee;\n    color: #555;\n    cursor: not-allowed;\n  }\n  ", " &[type='color'] {\n    min-height: 36px;\n  }\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledInput = styled.input(_templateObject(), function (_ref) {
  var inputStyles = _ref.inputStyles;
  return inputStyles || '';
}, function (_ref2) {
  var error = _ref2.error;
  return !error ? null : css(_templateObject2());
});

function BaseInput(props) {
  if (!props.id) {
    console.log('No id for', props);
    throw new Error("no id for props ".concat(JSON.stringify(props)));
  }

  var id = props.id,
      value = props.value,
      readonly = props.readonly,
      disabled = props.disabled,
      autofocus = props.autofocus,
      label = props.label,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      options = props.options,
      required = props.required,
      schema = props.schema,
      _props$formContext = props.formContext,
      formContext = _props$formContext === void 0 ? {} : _props$formContext,
      registry = props.registry,
      rawErrors = props.rawErrors,
      inputProps = _objectWithoutProperties(props, ["id", "value", "readonly", "disabled", "autofocus", "label", "onBlur", "onFocus", "options", "required", "schema", "formContext", "registry", "rawErrors"]);

  if (options && options.inputType) {
    inputProps.type = options.inputType;
  } else if (!inputProps.type) {
    if (schema && schema.type === 'number') {
      inputProps.type = 'number';
      inputProps.step = 'any';
    } else if (schema && schema.type === 'integer') {
      inputProps.type = 'number';
      inputProps.step = '1';
    } else {
      inputProps.type = 'text';
    }
  }

  if (schema && schema.multipleOf) {
    inputProps.step = schema.multipleOf;
  }

  var getOnChangeValue = function getOnChangeValue(v) {
    switch (inputProps.type) {
      case 'number':
        return v == null ? 0 : Number(v);

      default:
        return v == null ? '' : v;
    }
  };

  var _onChange = function _onChange(_ref3) {
    var v = _ref3.target.value;
    var emptyValue = options && options.emptyValue ? options.emptyValue : '';
    props.onChange(v === '' ? emptyValue : getOnChangeValue(v));
  };

  var getInputValue = function getInputValue() {
    switch (inputProps.type) {
      case 'number':
        return value == null ? '0' : value.toString();

      default:
        return value == null ? '' : value;
    }
  };

  return React__default.createElement("div", null, !schema && label ? React__default.createElement("label", {
    htmlFor: id
  }, label, required ? '*' : '') : null, React__default.createElement(StyledInput, _extends({
    id: id,
    className: "form-control ".concat(props.className),
    readOnly: readonly,
    disabled: disabled,
    value: getInputValue(),
    theme: formContext.theme,
    inputStyles: formContext.inputStyles,
    error: rawErrors && rawErrors.length
  }, inputProps, {
    onChange: _onChange,
    onBlur: onBlur && function (event) {
      return onBlur(inputProps.id, event.target.value);
    },
    onFocus: onFocus && function (event) {
      return onFocus(inputProps.id, event.target.value);
    }
  })));
}

BaseInput.defaultProps = {
  required: false,
  disabled: false,
  readonly: false,
  autofocus: false
};

var _NumberInput = function _NumberInput(props) {
  return React__default.createElement(BaseInput, _extends({
    type: "number"
  }, props));
};

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  padding: 10px;\n  border: 0;\n  border-radius: 4px;\n  background-color: #000;\n  color: #fff;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  text-align: center;\n  &:hover {\n    opacity: 0.8;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding-left: 28px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  &:before {\n    color: #000;\n    content: '", "';\n    position: absolute;\n    left: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  > * {\n    width: ", ";\n    max-width: ", ";\n    min-width: ", ";\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var InputRow = styled.div(_templateObject$1(), function (_ref) {
  var amounts = _ref.amounts;
  return "".concat(100 / (amounts.length + 1.5), "%");
}, function (_ref2) {
  var amounts = _ref2.amounts;
  return "".concat(100 / (amounts.length + 1.5), "%");
}, function (_ref3) {
  var amounts = _ref3.amounts;
  return "".concat(100 / (amounts.length + 1.5), "%");
});
var NumberInputSymbol = styled.div(_templateObject2$1(), function (_ref4) {
  var symbol = _ref4.symbol;
  return symbol;
});
var NumberInput = styled(_NumberInput)(_templateObject3());
var AmountButton = styled.div(_templateObject4());

var Amount = function Amount(props) {
  if (!props.id) {
    console.log('No id for', props);
    throw new Error("no id for props ".concat(JSON.stringify(props)));
  }

  var _props$amounts = props.amounts,
      amounts = _props$amounts === void 0 ? [] : _props$amounts;

  var id = props.id,
      value = props.value,
      label = props.label,
      _props$min = props.min,
      min = _props$min === void 0 ? 0 : _props$min,
      _props$onChange = props.onChange,
      _onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
      required = props.required,
      schema = props.schema,
      _props$symbol = props.symbol,
      symbol = _props$symbol === void 0 ? '€' : _props$symbol;

  amounts.concat([value]).forEach(function (a) {
    if (typeof a !== 'number') {
      throw new Error("props value/amounts should only be numbers");
    }
  });

  if (schema && schema.amounts) {
    // eslint-disable-next-line prefer-destructuring
    amounts = schema.amounts;
  }

  return React__default.createElement("div", null, !schema && label ? React__default.createElement("label", {
    htmlFor: id
  }, label, required ? '*' : '') : null, React__default.createElement(InputRow, {
    amounts: amounts
  }, amounts.map(function (x) {
    return React__default.createElement(AmountButton, {
      onClick: function onClick() {
        return _onChange(x);
      }
    }, symbol, " ", x / 100);
  }), React__default.createElement(NumberInputSymbol, {
    symbol: symbol
  }, React__default.createElement(NumberInput, {
    id: id,
    value: (value > min ? value : min) / 100,
    onChange: function onChange(v) {
      return _onChange((v > min ? v : min) * 100);
    }
  }))));
};

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  user-select: none;\n  height: 20px;\n  padding-left: 30px;\n  font-size: 16px;\n  display: inline-table;\n  &:after {\n    position: absolute;\n    width: 20px;\n    height: 20px;\n    background-color: #fff;\n    content: '';\n    top: 50%;\n    transform: translateY(-50%);\n    left: 0px;\n    z-index: 1;\n    border-radius: 4px;\n  }\n  &.checked:after {\n    background-color: #000;\n    content: '\u2713';\n    color: #fff;\n    padding: 0;\n    font-size: 12px;\n    line-height: 20px;\n    text-align: center;\n  }\n"], ["\n  position: relative;\n  user-select: none;\n  height: 20px;\n  padding-left: 30px;\n  font-size: 16px;\n  display: inline-table;\n  &:after {\n    position: absolute;\n    width: 20px;\n    height: 20px;\n    background-color: #fff;\n    content: '';\n    top: 50%;\n    transform: translateY(-50%);\n    left: 0px;\n    z-index: 1;\n    border-radius: 4px;\n  }\n  &.checked:after {\n    background-color: #000;\n    content: '\\u2713';\n    color: #fff;\n    padding: 0;\n    font-size: 12px;\n    line-height: 20px;\n    text-align: center;\n  }\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  opacity: 0;\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledInput$1 = styled.input(_templateObject$2());
var StyledLabel = styled.label(_templateObject2$2()); // JSON schema forms behaviour

function schemaRequiresTrueValue(schema) {
  if (schema["const"]) {
    return true;
  }

  if (schema["enum"] && schema["enum"].length === 1 && schema["enum"][0] === true) {
    return true;
  }

  if (schema.anyOf && schema.anyOf.length === 1) {
    return schemaRequiresTrueValue(schema.anyOf[0]);
  }

  if (schema.oneOf && schema.oneOf.length === 1) {
    return schemaRequiresTrueValue(schema.oneOf[0]);
  }

  if (schema.allOf) {
    return schema.allOf.some(schemaRequiresTrueValue);
  }
}

var Checkbox = function Checkbox(props) {
  var required = props.required;
  var schema = props.schema,
      id = props.id,
      value = props.value,
      disabled = props.disabled,
      readonly = props.readonly,
      label = props.label,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      _onChange = props.onChange;
  required = schema ? schemaRequiresTrueValue(schema) : required;
  return React__default.createElement("div", {
    className: "checkbox ".concat(disabled || readonly ? 'disabled' : '')
  }, schema && schema.description && React__default.createElement("p", null, schema.description), React__default.createElement(StyledInput$1, _extends({}, props, {
    type: "checkbox",
    id: id,
    checked: typeof value === 'undefined' ? false : value,
    required: required,
    disabled: disabled || readonly,
    onChange: function onChange(event) {
      return _onChange(event.target.checked);
    },
    onBlur: onBlur && function (event) {
      return onBlur(id, event.target.checked);
    },
    onFocus: onFocus && function (event) {
      return onFocus(id, event.target.checked);
    }
  })), React__default.createElement(StyledLabel, {
    className: value ? 'checked' : '',
    htmlFor: id,
    dangerouslySetInnerHTML: {
      __html: "".concat(label).concat(required ? '*' : '')
    }
  }));
};

var ColorInput = function ColorInput(props) {
  return React__default.createElement(BaseInput, _extends({
    type: "color"
  }, props));
};

var DateInput = function DateInput(props) {
  return React__default.createElement(BaseInput, _extends({
    type: "date"
  }, props));
};

var EmailInput = function EmailInput(props) {
  return React__default.createElement(BaseInput, _extends({
    type: "email"
  }, props));
};

var HiddenInput = function HiddenInput(props) {
  return React__default.createElement("input", _extends({
    type: "hidden",
    id: props.id,
    value: typeof value === 'undefined' ? '' : props.value
  }, props));
};

var PasswordInput = function PasswordInput(props) {
  return React__default.createElement(BaseInput, _extends({
    type: "password"
  }, props));
};

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  user-select: none;\n  height: 20px;\n  padding-left: 30px;\n  &:after {\n    position: absolute;\n    width: 20px;\n    height: 20px;\n    background-color: #fff;\n    content: '';\n    top: 50%;\n    transform: translateY(-50%);\n    left: 0px;\n    z-index: 1;\n    border-radius: 100%;\n  }\n  &.checked:after {\n    background-color: #000;\n    content: '\u2022';\n    color: #fff;\n    padding: 0;\n    font-size: 30px;\n    line-height: 22px;\n    text-align: center;\n  }\n"], ["\n  position: relative;\n  user-select: none;\n  height: 20px;\n  padding-left: 30px;\n  &:after {\n    position: absolute;\n    width: 20px;\n    height: 20px;\n    background-color: #fff;\n    content: '';\n    top: 50%;\n    transform: translateY(-50%);\n    left: 0px;\n    z-index: 1;\n    border-radius: 100%;\n  }\n  &.checked:after {\n    background-color: #000;\n    content: '\\u2022';\n    color: #fff;\n    padding: 0;\n    font-size: 30px;\n    line-height: 22px;\n    text-align: center;\n  }\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  opacity: 0;\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledInput$2 = styled.input(_templateObject$3());
var StyledLabel$1 = styled.label(_templateObject2$3());

var Radio = function Radio(props) {
  var schema = props.schema,
      options = props.options,
      value = props.value,
      required = props.required,
      disabled = props.disabled,
      readonly = props.readonly,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      _onChange = props.onChange,
      id = props.id;
  var _options$enumOptions = options.enumOptions,
      enumOptions = _options$enumOptions === void 0 ? [] : _options$enumOptions,
      enumDisabled = options.enumDisabled;
  return React__default.createElement("div", {
    className: "field-radio-group",
    id: id
  }, schema ? enumOptions.map(function (option, i) {
    var name = Math.random().toString();
    var checked = option.value === value;
    var itemDisabled = enumDisabled && enumDisabled.indexOf(option.value) !== -1;
    var disabledCls = disabled || itemDisabled || readonly ? 'disabled' : '';
    return React__default.createElement("div", {
      key: i,
      className: "radio ".concat(disabledCls),
      style: {
        margin: '10px 0'
      }
    }, React__default.createElement(StyledInput$2, {
      id: name,
      type: "radio",
      checked: checked,
      name: name,
      required: required,
      value: option.value,
      disabled: disabled || itemDisabled || readonly,
      onChange: function onChange(_) {
        return _onChange(option.value);
      },
      onBlur: onBlur && function (event) {
        return onBlur(id, event.target.value);
      },
      onFocus: onFocus && function (event) {
        return onFocus(id, event.target.value);
      }
    }), React__default.createElement(StyledLabel$1, {
      htmlFor: name,
      className: "".concat(checked ? 'checked ' : '')
    }, option.label));
  }) : options.map(function (option, i) {
    var name = Math.random().toString();
    var checked = option === value;
    var itemDisabled = enumDisabled && enumDisabled.indexOf(option) !== -1;
    var disabledCls = disabled || itemDisabled || readonly ? 'disabled' : '';
    return React__default.createElement("div", {
      key: i,
      className: "radio ".concat(checked ? 'checked ' : '').concat(disabledCls),
      style: {
        margin: '10px 0'
      }
    }, React__default.createElement(StyledInput$2, {
      id: name,
      type: "radio",
      checked: checked,
      name: name,
      required: required,
      value: option,
      disabled: disabled || itemDisabled || readonly,
      onChange: function onChange(_) {
        return _onChange(option);
      },
      onBlur: onBlur && function (event) {
        return onBlur(id, event.target.value);
      },
      onFocus: onFocus && function (event) {
        return onFocus(id, event.target.value);
      }
    }), React__default.createElement(StyledLabel$1, {
      htmlFor: name,
      className: "".concat(checked ? 'checked ' : '')
    }, option));
  }));
};

var asNumber = function asNumber(value) {
  if (value === '') {
    return undefined;
  }

  if (/\.$/.test(value)) {
    return value;
  }

  if (/\.0$/.test(value)) {
    return value;
  }

  var n = Number(value);
  var valid = typeof n === 'number' && !Number.isNaN(n);

  if (/\.\d*0$/.test(value)) {
    return value;
  }

  return valid ? n : value;
};

var getRange = function getRange(props) {
  var min = props.min,
      max = props.max,
      step = props.step,
      schema = props.schema;
  var spec = {};

  if (schema) {
    if (schema.multipleOf) {
      spec.step = schema.multipleOf;
    }

    if (schema.minimum || schema.minimum === 0) {
      spec.min = schema.minimum;
    }

    if (schema.maximum || schema.maximum === 0) {
      spec.max = schema.maximum;
    }
  } else {
    spec.min = min;
    spec.max = max;
    spec.step = step;
  }

  return spec;
};

var getValue = function getValue(event, multiple) {
  if (multiple) {
    return [].slice.call(event.target.options).filter(function (o) {
      return o.selected;
    }).map(function (o) {
      return o.value;
    });
  }

  return event.target.value;
};

var guessType = function guessType(value) {
  if (Array.isArray(value)) {
    return 'array';
  }

  if (typeof value === 'string') {
    return 'string';
  }

  if (value == null) {
    return 'null';
  }

  if (typeof value === 'boolean') {
    return 'boolean';
  }

  if (!Number.isNaN(value)) {
    return 'number';
  }

  if (_typeof(value) === 'object') {
    return 'object';
  }

  return 'string';
};

var processValue = function processValue(schema, value) {
  var type = schema.type,
      items = schema.items;
  var nums = new Set(['number', 'integer']);

  if (value === '') {
    return undefined;
  }

  if (type === 'array' && items && nums.has(items.type)) {
    return value.map(asNumber);
  }

  if (type === 'boolean') {
    return value === 'true';
  }

  if (type === 'number') {
    return asNumber(value);
  }

  if (schema["enum"]) {
    if (schema["enum"].every(function (x) {
      return guessType(x) === 'number';
    })) {
      return asNumber(value);
    }

    if (schema["enum"].every(function (x) {
      return guessType(x) === 'boolean';
    })) {
      return value === 'true';
    }
  }

  return value;
};

var RangeInput = function RangeInput(props) {
  return React__default.createElement(BaseInput, _extends({
    type: "range"
  }, props, getRange(props)));
};

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  cursor: pointer;\n  &:after {\n    pointer-events: none;\n    position: absolute;\n    display: block;\n    content: '';\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 0;\n    height: 0;\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-top: 10px solid ", ";\n  }\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  font-size: inherit;\n  padding: 10px;\n  border-radius: 4px;\n  border: none;\n  width: 100%;\n  background-color: #fff;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  position: relative;\n  cursor: pointer;\n  &:disabled {\n    background-color: #eee;\n    color: #555;\n    cursor: not-allowed;\n  }\n  ", ";\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledSelect = styled.select(_templateObject$4(), function (_ref) {
  var selectStyles = _ref.selectStyles;
  return selectStyles || '';
});
var Wrapper = styled.div(_templateObject2$4(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.formBackgroundColor;
});

var Select = function Select(props) {
  var schema = props.schema,
      id = props.id,
      _props$options = props.options,
      options = _props$options === void 0 ? {} : _props$options,
      value = props.value,
      required = props.required,
      disabled = props.disabled,
      readonly = props.readonly,
      label = props.label,
      multiple = props.multiple,
      _props$formContext = props.formContext,
      formContext = _props$formContext === void 0 ? {} : _props$formContext,
      _onChange = props.onChange,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      placeholder = props.placeholder;
  var _options$enumOptions = options.enumOptions,
      enumOptions = _options$enumOptions === void 0 ? [] : _options$enumOptions,
      enumDisabled = options.enumDisabled;
  var emptyValue = multiple ? [] : '';
  return React__default.createElement(Wrapper, null, !schema && label ? React__default.createElement("label", {
    htmlFor: id
  }, label, required ? '*' : '') : null, React__default.createElement(StyledSelect, {
    id: id,
    multiple: multiple,
    className: "form-control",
    value: typeof value === 'undefined' ? emptyValue : value,
    required: required,
    disabled: disabled || readonly,
    selectStyles: formContext.selectStyles,
    onBlur: onBlur && function (event) {
      var newValue = getValue(event, multiple);
      onBlur(id, schema ? processValue(schema, newValue) : newValue);
    },
    onFocus: onFocus && function (event) {
      var newValue = getValue(event, multiple);
      onFocus(id, schema ? processValue(schema, newValue) : newValue);
    },
    onChange: function onChange(event) {
      var newValue = getValue(event, multiple);

      _onChange(schema ? processValue(schema, newValue) : newValue);
    }
  }, schema ? React__default.createElement(React.Fragment, null, !multiple && schema["default"] === undefined && React__default.createElement("option", {
    value: ""
  }, placeholder), enumOptions.map(function (_ref3, i) {
    var value = _ref3.value,
        label = _ref3.label;
    var disabledOption = enumDisabled && enumDisabled.indexOf(value) !== -1;
    return (// eslint-disable-next-line react/no-array-index-key
      React__default.createElement("option", {
        key: i,
        value: value,
        disabled: disabledOption
      }, label)
    );
  })) : React__default.createElement(React.Fragment, null, options.map(function (x, i) {
    return (// eslint-disable-next-line react/no-array-index-key
      React__default.createElement("option", {
        key: i,
        value: x
      }, x)
    );
  }))));
};

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  min-width: 100%;\n  max-width: 100%;\n  font-size: inherit;\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledTextarea = styled.textarea(_templateObject$5());

var Textarea = function Textarea(props) {
  var id = props.id,
      _props$options = props.options,
      options = _props$options === void 0 ? {} : _props$options,
      placeholder = props.placeholder,
      value = props.value,
      required = props.required,
      disabled = props.disabled,
      readonly = props.readonly,
      onChange = props.onChange,
      onBlur = props.onBlur,
      onFocus = props.onFocus;

  var _onChange = function _onChange(_ref) {
    var val = _ref.target.val;
    return onChange(val === '' ? options.emptyValue || '' : val);
  };

  return React__default.createElement(StyledTextarea, {
    id: id,
    className: "form-control",
    value: value,
    placeholder: placeholder,
    required: required,
    disabled: disabled,
    readOnly: readonly,
    rows: options.rows,
    onBlur: onBlur && function (event) {
      return onBlur(id, event.target.value);
    },
    onFocus: onFocus && function (event) {
      return onFocus(id, event.target.value);
    },
    onChange: _onChange
  });
};

var URLInput = function URLInput(props) {
  return React__default.createElement(BaseInput, _extends({
    type: "url"
  }, props));
};

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n  fieldset {\n    border: 0;\n  }\n  .form-group {\n    margin-bottom: 10px;\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledForm = styled(Form)(_templateObject$6());
var defaultWidgets = {
  CheckboxWidget: Checkbox,
  ColorWidget: ColorInput,
  DateWidget: DateInput,
  EmailWidget: EmailInput,
  HiddenWidget: HiddenInput,
  PasswordWidget: PasswordInput,
  RangeWidget: RangeInput,
  RadioWidget: Radio,
  SelectWidget: Select,
  TextWidget: BaseInput,
  TextareaWidget: Textarea,
  URLWidget: URLInput
};

function SchemaForm(_ref) {
  var _ref$widgets = _ref.widgets,
      widgets = _ref$widgets === void 0 ? function (v) {
    return v;
  } : _ref$widgets,
      props = _objectWithoutProperties(_ref, ["widgets"]);

  return React__default.createElement(StyledForm, _extends({
    ErrorList: function ErrorList() {
      return null;
    },
    transformErrors: function transformErrors(errors) {
      return errors.map(function (error) {
        if (error.name === 'required') {
          error.message = 'this field is required'; // eslint-disable-line no-param-reassign
        } else {
          error.message = ''; // eslint-disable-line no-param-reassign
        }

        return error;
      });
    }
  }, props, {
    widgets: widgets(defaultWidgets)
  }));
}

SchemaForm._Amount = Amount;
module.exports = SchemaForm;